// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_string from "../../../../../node_modules/rescript/lib/es6/js_string.js";
import Link from "next/link";
import * as NextImage$PorterinFeature from "./NextImage.mjs";
import * as CityContext$PorterinFeature from "../../contexts/city-context/CityContext.mjs";
import * as GAEventsConstants$PorterinFeature from "../../shared/core/constants/GAEventsConstants.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../shared/core/helpers/PublishEventsHelper.mjs";
import * as CategoryCardModuleScss from "../styles/common/CategoryCard.module.scss";

var styles = CategoryCardModuleScss;

function CategoryCardCmp(Props) {
  var service = Props.service;
  var is_redirecting = Props.is_redirecting;
  var setIsRedirecting = Props.setIsRedirecting;
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var createElementId = function (param) {
    var service_text = Js_string.replaceByRe(/\s+/g, "", service.text);
    return "category-card-" + service_text + "";
  };
  return React.createElement(Link, {
              href: service.link + citySelectedContext.query_params,
              children: React.createElement("div", {
                    className: styles["category-card"],
                    id: createElementId(undefined),
                    onClick: (function (param) {
                        if (is_redirecting) {
                          return ;
                        } else {
                          Curry._1(setIsRedirecting, (function (param) {
                                  return true;
                                }));
                          PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, service.text + GAEventsConstants$PorterinFeature.gaCategoryCardAction, service.link);
                          PublishEventsHelper$PorterinFeature.publishCategoryCardEvent(citySelectedContext.category, service.text, service.link);
                          return PublishEventsHelper$PorterinFeature.fireCategoryCompareEvent(service.text);
                        }
                      })
                  }, React.createElement("div", {
                        className: styles["icon-bg"]
                      }, React.createElement(NextImage$PorterinFeature.make, {
                            src: service.image.path,
                            height: 200.0,
                            width: 200.0,
                            quality: 100.0,
                            alt: service.image.alt_text
                          })), React.createElement("div", {
                        className: styles.text
                      }, service.text)),
              target: "_parent"
            });
}

var Link$1;

var make = CategoryCardCmp;

export {
  Link$1 as Link,
  styles ,
  make ,
}
/* styles Not a pure module */
